import Petition from "../../../modules/petition";
const pet = new Petition()

export class CBService {
    welcome() {
        return 'welcome to ApiService';
    }
    example() {
        return pet.get('http://api.150porciento.com/api/countries')
    }
    getRecipes(filters?: any) {
        if (filters) {
            let category = filters.category ? `category=${filters.category}` : 'category='
            let subcategory = filters.subcategory ? `subcategory=${filters.subcategory}` : 'subcategory='
            let filter = filters.filter ? `filter=${filters.filter}` : 'filter='

            return pet.get(`/meals/premium/recetas?${category}&${subcategory}&${filter}`);
        }
        return pet.get('/meals/premium/recetas');
    }
}